import m from 'mithril'
import stream from 'mithril/stream'
import storage from 'core/services/storage'

const storageKey = 'iceworm-state'
const appState = stream(storage.get(storageKey) || {})
let debug = false

const debugMessage = (message, object = '') => {
  if (debug) {
    console.log(`[appState] ${message}`, object)
  }
}

const get = key => {
  return key ? appState()[key] : appState()
}

const set = (state, options = {}, callback = () => {}) => {
  const defaults = {
    store: true,
    redraw: true,
    debug: window.HeliosDebug || false,
    ...options
  }

  const opts =
    typeof options !== 'object'
      ? defaults
      : {
          ...defaults,
          ...options
        }

  debug = opts.debug

  debugMessage('Sent state:', state)

  if (typeof state === 'object') {
    const newState = appState({
      ...appState(),
      ...state
    })

    debugMessage('New state:', newState)

    if (opts.store) {
      storage.set(storageKey, newState)
    }

    if (opts.redraw) {
      debugMessage('Redrawing')
      m.redraw()
    }

    if (typeof options === 'function') {
      options(newState)
    } else {
      callback(newState)
    }
  } else {
    const error = new Error('State parameter is not an object.')
    console.error(error)
    throw error
  }
}

export const getAppState = get
export const setAppState = set

export default { get, set }
